var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0.241258175,3.21487322 C0.533910624,3.50752567 0.998711572,3.53621709 1.31431715,3.27225606 C3.99409546,1.06875527 7.88465154,1.06875527 10.5701681,3.26651777 C10.891512,3.5304788 11.3620512,3.50752567 11.6547037,3.21487322 C11.9932624,2.87631451 11.9703093,2.31396274 11.5973208,2.00983373 C8.32076107,-0.669944576 3.58093906,-0.669944576 0.298641009,2.00983373 C-0.0743474064,2.30822446 -0.103038823,2.87057622 0.241258175,3.21487322 Z M4.69416602,7.66778107 L5.53769367,8.51130871 C5.76148672,8.73510176 6.12299856,8.73510176 6.34679161,8.51130871 L7.19031926,7.66778107 C7.46001857,7.39808175 7.40263574,6.9332808 7.05833874,6.75539402 C6.35826818,6.39388217 5.52047882,6.39388217 4.81466997,6.75539402 C4.48758782,6.9332808 4.42446671,7.39808175 4.69416602,7.66778107 Z M2.55378635,5.52740139 C2.83496223,5.80857728 3.27681004,5.83726869 3.60389219,5.60199908 C5.00403332,4.60927607 6.88619024,4.60927607 8.28633137,5.60199908 C8.61341352,5.83153041 9.05526133,5.80857728 9.33643721,5.52740139 L9.3421755,5.52166311 C9.6864725,5.17736611 9.66351936,4.59206122 9.26757782,4.31088533 C7.29360836,2.88205279 4.60235349,2.88205279 2.62264575,4.31088533 C2.2267042,4.5977995 2.20375107,5.17736611 2.55378635,5.52740139 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4.167 5.833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(-4.167 -5.833)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOn);
export default __webpack_public_path__ + "static/media/wifi_on.8202809ea24a7aa8621b5bf010acbdb4.svg";
export { ForwardRef as ReactComponent };